// ========== Edition Tag 相关文案 (从 edition-upgrade 搬运) ==========
const editionTag = {
    freemium: '免费版',
    upgrade: '立即升级',
};

const packageDiff = {
    singleAirUpgrade: {
        title: '升级解锁更多权益',
        description: '升级到高级版,解锁更多功能和数据权限',
        buttonText: '立即升级',
        features: {
            1: '无限次AI对话次数',
            2: '高级图表可视化功能',
            3: '专属客服支持',
        },
    },
};

const history = {
    empty: '暂无历史记录',
    searchPlaceholder: '搜索历史记录',
    today: '今天',
    yesterday: '昨天',
};

const PtUserBanner = {
    more: '查看全部 →',
    protect_free: '技术保护',
    protect_trial: '技术保护',
    protect_commercial_old: '技术保护',
    protect_commercial: '技术保护',
    material_trial: '新材料',
    material_commercial_old: '新材料',
    material_commercial: '新材料',
    material_commercial_rapid_search: '材料速研版',
    air_free: 'Eureka 基础版',
    air_trial: '技术方案',
    air_commercial: '技术方案',
    unlock_skills_trial: 'Eureka 试用版',
    insights_trial: '研发情报',
    insights_commercial: '研发情报',
    air_commercial_professional_edition: '研发专业版',
    air_commercial_professional_edition_trial: '研发专业版',
    air_commercial_navigator_edition: '研发领航版',
    air_commercial_navigator_edition_trial: '研发领航版',
    feishu_trial: 'Eureka 研发专业版（试用）',
    ls_trial: '生物医药 (试用)',
    ls_trial_five: '生物医药',
    ls_commercial: '生物医药',
    ls_commercial_share: '生物医药专业版',
    ls_commercial_share_trial: '生物医药 (试用)',
    ls_trial_hiro: '生物医药百科问答 & 文档精读 (试用)',
    ls_trial_hiro_full: '生物医药百科问答 & 文档精读 (试用)',
    ls_commercial_hiro: '生物医药百科问答 & 文档精读',
    ls_commercial_pharma: '生物医药百科问答 & 文档精读',
    ls_commercial_draft: '马库什权要撰写 ',
    ls_commercial_antibody: '优选抗体推荐',
    ls_commercial_launch: '药物知产报告',
    ls_commercial_agent: '生物医药增强包',
    ip_commercial: '知识产权',
    ip_trial_novelty_drafting: '知识产权',
    ip_trial_infringement: '防侵权检索',
    ip_trial_novelty: '查新检索',
    ip_commercial_specification_cnipa: '专利说明书撰写(CNIPA)',
    ip_commercial_specification_uspto: '专利说明书撰写(USPTO)',
    ip_commercial_specification_epo: '专利说明书撰写(EPO)',
    ip_commercial_design_infringement: '外观防侵权检索',
    ip_commercial_infringement: '防侵权检索',
    ip_commercial_disclosure: '技术交底书撰写',
    ip_commercial_translation: '专利翻译',
    ip_commercial_novelty: '查新检索',
    ip_commercial_novelty_draft: 'AI查新&撰写',
    ip_commercial_draft: 'AI撰写',
    ip_plg_free: 'Eureka IP 通用流量(免费版)',
    GENERAL_FREEMIUM: '免费版',

    rd_plg_freemium: 'Eureka 基础版',
    rd_personal_commercial: 'Eureka 工程创新 个人版',
    agent_personal_commercial: 'Eureka 个人付费版',
    material_pro: 'MSE Pro',
    ls_plg_personal_pro: 'LS Pro',
    // 和 MainPackageEnum对应
    ip_checking_pro: 'IP 检索 专业版',
    ip_checking_pro_year: 'IP 检索 专业版',
    ip_checking_enterprise: 'IP 检索 企业版',
};

// ========== Edition Tag 相关文案结束 ==========
const histroySearch = {
    Hiro: '芽仔',
    EOU: '侵权线索发现',
    NoveltySearch: '查新检索',
    FTOSearch: '防侵权检索',
    DesignFTOSearch: '外观防侵权检索',
    PatentApplication: '专利申请',
    OAR: '审查意见答复',
    InventionDisclosure: '交底书',
    CustomCap: '自定义能力',
    Telecom: '对标分析',
};
export const cn = {
    editionTag,
    packageDiff,
    history,
    histroySearch,
    PtUserBanner,
    IpHeader: {
        ip: 'IP',
        features: '功能介绍',
        pricing: '报价',
        getStarted: '开始体验',
    },
    AIHistoryNav: {
        open: '展开侧栏',
        close: '关闭侧栏',
    },
    NavBar: {
        HOME: '首页',
        NEW_TASKS: '新任务',
        SEARCH_TASKS: '搜索任务',
        KNOWLEDGE_BASE: '知识库',
        MONITOR: '情报简报',
        COMMUNITY: '发现广场',
        AGENT: '智能体',
        CUSTOMIZE: '个性化',
        DRAFTING: '撰写',
        AI_STUDIO: 'AI 工作站',
        AI_GENERATE: 'AI Agent',
        WORKSPACE: '工作空间',
        CUSTOM_AGENT: '探索',
        WORK_PROJECT: '项目',
        MONITOR_TOPIC: '技术库',
        MONITOR_SUBSCRIPTION: '我的监控',
        HISTORY: '最近任务',
        DraftingCenter: '撰写中心',
        Templates: '模板',
        AIInstructions: '指令',
        WritingStyles: '撰写风格',
        deleteTitle: '确认删除记录',
        deleteContent: '您确定要永久删除此记录吗？删除后将无法恢复此数据。',
        cancel: '取消',
        confirm: '删除',
        deleteSuccess: '您的记录已成功删除',
        open: '展开侧栏',
        close: '关闭侧栏',
        INCOGNITO: '已开启无痕模式',
        INCOGNITO_TIP: '无痕模式下，您的搜索记录将不会被保存',
        deleteAllTitle: '确认删除所有缓存及已有记录',
        deleteAllContent: '您确定要删除所有数据吗？删除后将无法恢复, 您分享的内容也将立即失效。',
        historyViewAll: '全部历史',
        creditsLabel: '积分',
        manageSubscription: '管理订阅',
    },
    HistoryType: {
        SEEK_SEARCH: '技术信息问答​',
        TECH_MIND: '技术方案探索',
        RD_TECH_MIND: '技术方案探索',
        TECH_RESEARCH: '技术预研报告',
        TECH_FMEA: '设计失效分析',
        PATENT_DISCLOSURE: '专利交底书助手',
        MATERIAL_MIND: '技术方案探索 材料',
        AI_TRANSLATION: '专利翻译',
        AI_SPECIFICATION: '专利说明书撰写',
        AI_PATENT_DISCLOSURE: '技术交底书撰写',
        AI_NOVELTY_SEARCH: '查新检索',
        AI_NOVELTY_SEARCH_V2: '查新检索',
        AI_FTO_SEARCH: '防侵权检索',
        AI_NEW_FTO_SEARCH: '防侵权检索',
        AI_FTO_IMAGE: '外观防侵权检索',
        AI_EOU_AGENT: '侵权线索发现',
        AI_INVALID_SEARCH: '专利无效分析',
        AI_GENERATE: 'AI Agent',
        LS_DOCUMENT_QA: 'Biomed Document Analysis',
        LS_CHAT: 'Biomed Q&A Hub',
        LS_MARKUSH_PATENT_DRAFT: 'Markush Claim Drafting',
        TRIZ_MIND: '解决方案探索 - Triz',
    },
    GuestToMaster: {
        subject: '免费注册',
        rights: 'Eureka 赋能您的创新全流程，让创新更专注、更高效。',
    },
};

// ========== Edition Tag 相关文案 (从 edition-upgrade 搬运) ==========
const editionTagEn = {
    freemium: 'Free',
    upgrade: 'Upgrade',
};

const packageDiffEn = {
    singleAirUpgrade: {
        title: 'Eureka Agent Platform',
        description: 'Upgrade to Premium for more features and data access',
        buttonText: 'Upgrade Now',
        features: {
            1: 'Unlimited AI conversations',
            2: 'Advanced chart visualization',
            3: 'Priority customer support',
        },
    },
};

const historyEn = {
    empty: 'No tasks yet',
    searchPlaceholder: 'Search tasks',
    today: 'Today',
    yesterday: 'Yesterday',
};

const PtUserBannerEn = {
    more: 'More →',
    protect_free: 'Eureka Search',
    protect_trial: 'Eureka Search',
    protect_commercial_old: 'Eureka Search',
    protect_commercial: 'Eureka Search',
    material_trial: 'Eureka Materials',
    material_commercial_old: 'Eureka Materials',
    material_commercial: 'Eureka Materials',
    material_commercial_rapid_search: 'Materials Express',
    air_free: 'Eureka Basic',
    air_trial: 'Eureka Ideas',
    air_commercial: 'Eureka Ideas',
    unlock_skills_trial: 'Eureka Trial',
    insights_trial: 'Eureka Scout',
    insights_commercial: 'Eureka Scout',
    air_commercial_professional_edition: 'R&D Professional Edition',
    air_commercial_professional_edition_trial: 'R&D Professional Edition',
    air_commercial_navigator_edition: 'R&D Pilot Edition',
    air_commercial_navigator_edition_trial: 'R&D Pilot Edition',
    feishu_trial: 'Eureka R&D Professional Edition (Trial)',
    ls_trial: 'Life Sciences (Trial)',
    ls_trial_five: 'Life Sciences',
    ls_commercial: 'Life Sciences',
    ls_commercial_share: 'Life Sciences Professional',
    ls_commercial_share_trial: 'Life Sciences (Trial)',
    ls_trial_hiro: 'Life Sciences - PIA & PDA (Trial)',
    ls_trial_hiro_full: 'Life Sciences - PIA & PDA (Trial)',
    ls_commercial_hiro: 'Life Sciences - PIA & PDA',
    ls_commercial_pharma: 'Life Sciences - PIA & PDA',
    ls_commercial_draft: 'Life Sciences - MCD',
    ls_commercial_antibody: 'Life Sciences - ATP',
    ls_commercial_launch: 'Life Sciences - PCIE',
    ls_commercial_agent: 'Life Sciences Usage Package',
    ip_commercial: 'IP',
    ip_trial_novelty_drafting: 'IP',
    ip_trial_infringement: 'IP - FTO Search',
    ip_trial_novelty: 'IP - Novelty Search',
    ip_commercial_specification_cnipa: 'IP - Patent Drafting (CNIPA)',
    ip_commercial_specification_uspto: 'IP - Patent Drafting (USPTO)',
    ip_commercial_specification_epo: 'IP - Patent Drafting (EPO)',
    ip_commercial_design_infringement: 'IP - Design FTO Search',
    ip_commercial_infringement: 'IP - FTO Search',
    ip_commercial_disclosure: 'IP - Invention Disclosure',
    ip_commercial_translation: 'IP - Patent Translation',
    ip_commercial_novelty: 'IP - Novelty Search',
    ip_commercial_novelty_draft: 'IP - AI Novelty Search & AI Drafting',
    ip_commercial_draft: 'IP - AI Drafting',
    ip_plg_free: 'Eureka IP General Traffic (Free)',
    GENERAL_FREEMIUM: 'Free',

    rd_plg_freemium: 'Eureka Basic',
    rd_personal_commercial: 'Eureka ENG PRO',
    agent_personal_commercial: 'Eureka Pro',
    material_pro: 'MSE Pro',
    ls_plg_personal_pro: 'LS Pro',
    ip_checking_pro: 'IP Searching Pro',
    ip_checking_pro_year: 'IP Searching Pro',
    ip_checking_enterprise: 'IP Searching Enterprise',
};

const histroySearchEn = {
    Hiro: 'Hiro',
    EOU: 'Evidence of Use',
    NoveltySearch: 'Novelty Search',
    FTOSearch: 'FTO Search',
    DesignFTOSearch: 'Design FTO Search',
    PatentApplication: 'Patent Application',
    OAR: 'OA Response',
    InventionDisclosure: 'Invention Disclosure',
    CustomCap: 'Custom Capability',
    Telecom: 'Standard Comparison',
};
// ========== Edition Tag 相关文案结束 ==========

export const en = {
    editionTag: editionTagEn,
    packageDiff: packageDiffEn,
    history: historyEn,
    histroySearch: histroySearchEn,
    PtUserBanner: PtUserBannerEn,
    IpHeader: {
        ip: 'IP',
        features: 'Features',
        pricing: 'Pricing',
        getStarted: 'Get Started',
    },
    AIHistoryNav: {
        open: 'Expand Sidebar',
        close: 'Collapse Sidebar',
    },
    NavBar: {
        HOME: 'Homepage',
        NEW_TASKS: 'New Task',
        SEARCH_TASKS: 'Search Tasks',
        KNOWLEDGE_BASE: 'Vault',
        MONITOR: 'Pulse',
        COMMUNITY: 'Gallery',
        AGENT: 'Agent',
        CUSTOMIZE: 'Customize',
        DRAFTING: 'Drafting',
        AI_STUDIO: 'AI Studio',
        AI_GENERATE: 'AI Agent',
        WORKSPACE: 'Workspace',
        CUSTOM_AGENT: 'Explore',
        WORK_PROJECT: 'Project',
        MONITOR_TOPIC: 'Library',
        MONITOR_SUBSCRIPTION: 'My Monitor',
        HISTORY: 'Recents',
        DraftingCenter: 'Drafting Center',
        Templates: 'Templates',
        AIInstructions: 'AI Instructions',
        WritingStyles: 'Writing Styles',
        deleteTitle: 'Confirm Record Deletion',
        deleteContent: 'Are you sure you want to permanently delete this record? This action cannot be undone.',
        cancel: 'Cancel',
        confirm: 'Delete',
        deleteSuccess: 'Your record has been deleted successfully',
        open: 'Expand Sidebar',
        close: 'Collapse Sidebar',
        INCOGNITO: 'Incognito Mode',
        INCOGNITO_TIP: 'In Incognito Mode, your search history will not be saved.',
        deleteAllTitle: 'Confirm Deletion of All Cache and Existing Records',
        deleteAllContent: 'Are you sure you want to delete all data? This action cannot be undone, and any content you have shared will immediately become inaccessible.',
        historyViewAll: 'All History',
        creditsLabel: 'Credits',
        manageSubscription: 'Manage Subscription',
    },
    HistoryType: {
        SEEK_SEARCH: 'Scope problem',
        TECH_MIND: 'Find solutions',
        RD_TECH_MIND: 'Find solutions',
        TECH_RESEARCH: 'Quick research',
        TECH_FMEA: 'DFMEA Assistant',
        PATENT_DISCLOSURE: 'Invention disclosure assistant',
        MATERIAL_MIND: 'Find solutions  Materials',
        AI_TRANSLATION: 'Patent Translation',
        AI_SPECIFICATION: 'Patent Specification',
        AI_PATENT_DISCLOSURE: 'Invention Disclosure',
        AI_NOVELTY_SEARCH: 'Novelty Search',
        AI_NOVELTY_SEARCH_V2: 'Novelty Search',
        AI_FTO_SEARCH: 'FTO Search',
        AI_NEW_FTO_SEARCH: 'FTO Search',
        AI_FTO_IMAGE: 'Design FTO',
        AI_EOU_AGENT: 'Evidence of Use',
        AI_INVALID_SEARCH: 'Invalid Search',
        AI_GENERATE: 'AI Agent',
        LS_DOCUMENT_QA: 'Biomed Document Analysis',
        LS_CHAT: 'Biomed Q&A Hub',
        LS_MARKUSH_PATENT_DRAFT: 'Markush Claim Drafting',
        TRIZ_MIND: 'Find solution - Triz',
    },
    GuestToMaster: {
        subject: 'Try it for free',
        rights: 'Automate and accelerate your workflows with Eureka\'s AI agents.',
    },
};

// ========== Edition Tag 相关文案 (从 edition-upgrade 搬运) ==========
const editionTagJp = {
    freemium: '無料版',
    upgrade: 'アップグレード',
};

const packageDiffJp = {
    singleAirUpgrade: {
        title: 'アップグレードして更多权益',
        description: 'プレミアム版にアップグレードして更多機能とデータアクセス',
        buttonText: '今すぐアップグレード',
        features: {
            1: '無制限のAI会話',
            2: '高度なチャート可視化',
            3: '優先カスタマーサポート',
        },
    },
};

const historyJp = {
    empty: 'タスクはまだありません',
    searchPlaceholder: 'タスクを検索',
    today: '今日',
    yesterday: '昨日',
};

const PtUserBannerJp = {
    more: '続き →',
    protect_free: '計画保護',
    protect_trial: '計画保護',
    protect_commercial_old: '計画保護',
    protect_commercial: '計画保護',
    material_trial: '材料科学',
    material_commercial_old: '材料科学',
    material_commercial: '材料科学',
    material_commercial_rapid_search: '材料クイック研究版',
    air_free: 'Eureka 基礎版',
    air_trial: '研究開発計画',
    air_commercial: '研究開発計画',
    unlock_skills_trial: 'Eureka 体験版',
    insights_trial: 'Eureka Scout',
    insights_commercial: 'Eureka Scout',
    air_commercial_professional_edition: '研究開発プロフェッショナル版',
    air_commercial_professional_edition_trial: '研究開発プロフェッショナル版',
    air_commercial_navigator_edition: '研究開発ナビゲーター版',
    air_commercial_navigator_edition_trial: '研究開発ナビゲーター版',
    feishu_trial: 'Eureka 研究開発プロフェッショナル版（体験版）',
    ls_trial: 'ライフサイエンス (試用)',
    ls_trial_five: 'ライフサイエンス',
    ls_commercial: 'ライフサイエンス',
    ls_commercial_share: 'ライフサイエンス プロフェッショナル版',
    ls_commercial_share_trial: 'ライフサイエンス (試用)',
    ls_trial_hiro: 'ライフサイエンス百科Q&A & 文書精読 (試用)',
    ls_trial_hiro_full: 'ライフサイエンス百科Q&A & 文書精読 (試用)',
    ls_commercial_hiro: 'ライフサイエンス百科Q&A & 文書精読',
    ls_commercial_pharma: 'ライフサイエンス百科Q&A & 文書精読',
    ls_commercial_draft: 'マーカッシュ権利要件作成',
    ls_commercial_antibody: '最適抗体推薦',
    ls_commercial_launch: '医薬知財レポート',
    ls_commercial_agent: 'ライフサイエンス 拡張パック',
    ip_commercial: 'IP',
    ip_trial_novelty_drafting: 'IP',
    ip_trial_infringement: 'IP - FTO Search',
    ip_trial_novelty: 'IP - Novelty Search',
    ip_commercial_specification_cnipa: 'IP - Patent Drafting (CNIPA)',
    ip_commercial_specification_uspto: 'IP - Patent Drafting (USPTO)',
    ip_commercial_specification_epo: 'IP - Patent Drafting (EPO)',
    ip_commercial_design_infringement: 'IP - 意匠FTO調査',
    ip_commercial_infringement: 'IP - FTO Search',
    ip_commercial_disclosure: 'IP - Invention Disclosure',
    ip_commercial_translation: 'IP - Patent Translation',
    ip_commercial_novelty: 'IP - Novelty Search',
    ip_commercial_novelty_draft: 'IP - AI Novelty Search & AI Drafting',
    ip_commercial_draft: 'IP - AI Drafting',
    ip_plg_free: 'Eureka IP ユニバーサルトラフィック(無料版)',
    GENERAL_FREEMIUM: '無料版',

    rd_plg_freemium: 'Eureka 基礎版',
    rd_personal_commercial: 'Eureka エンジニアリングイノベーション 個人版',
    agent_personal_commercial: 'Eureka 個人付費版',
    material_pro: 'MSE Pro',
    ls_plg_personal_pro: 'LS Pro',
    ip_checking_pro: 'IP Searching Pro',
    ip_checking_pro_year: 'IP Searching Pro',
    ip_checking_enterprise: 'IP Searching Enterprise',
};

// ========== Edition Tag 相关文案结束 ==========
const histroySearchJp = {
    Hiro: 'Hiro',
    EOU: 'Evidence of Use',
    NoveltySearch: '新規性調査',
    FTOSearch: 'FTO調査',
    DesignFTOSearch: '意匠FTO調査',
    PatentApplication: '特許出願',
    OAR: '拒絶理由対応',
    InventionDisclosure: '発明開示書',
    CustomCap: 'カスタマイズ機能',
    Telecom: 'ベンチマーク分析',
};
export const jp = {
    editionTag: editionTagJp,
    packageDiff: packageDiffJp,
    history: historyJp,
    histroySearch: histroySearchJp,
    PtUserBanner: PtUserBannerJp,
    IpHeader: {
        ip: 'IP',
        features: '機能紹介',
        pricing: '価格',
        getStarted: '今すぐスタート',
    },
    AIHistoryNav: {
        open: 'サイドバーを展開',
        close: 'サイドバーを閉じる',
    },
    NavBar: {
        HOME: 'ホーム',
        NEW_TASKS: '新しいタスク',
        SEARCH_TASKS: '検索タスク',
        KNOWLEDGE_BASE: 'ボールト',
        MONITOR: '動向モニター',
        COMMUNITY: '発見広場',
        AGENT: 'エージェント',
        CUSTOMIZE: 'カスタマイズ',
        DRAFTING: '作成',
        AI_STUDIO: 'AI 工作站',
        AI_GENERATE: 'AI Agent',
        WORKSPACE: 'ワークスペース',
        CUSTOM_AGENT: 'Explore',
        WORK_PROJECT: 'プロジェクト',
        MONITOR_TOPIC: '技術ライブラリ',
        MONITOR_SUBSCRIPTION: '私の監視',
        HISTORY: '最近のタスク',
        DraftingCenter: '作成センター',
        Templates: 'テンプレート',
        AIInstructions: '指示',
        WritingStyles: '執筆スタイル',
        deleteTitle: '記録削除の確認',
        deleteContent: 'この記録を完全に削除してもよろしいですか？削除後、このデータは復元できません。',
        cancel: 'キャンセル',
        confirm: '削除',
        deleteSuccess: '記録が削除されました',
        open: 'サイドバーを展開',
        close: 'サイドバーを閉じる',
        INCOGNITO: 'シークレット有効',
        INCOGNITO_TIP: 'シークレットモードでは、検索履歴は保存されません。',
        deleteAllTitle: 'すべてのキャッシュと既存の記録を削除しますか？',
        deleteAllContent: 'すべてのデータを削除してもよろしいですか？この操作は元に戻すことができません。共有したコンテンツもすぐにアクセスできなくなります。',
        historyViewAll: 'すべての履歴',
        creditsLabel: '積分',
        manageSubscription: 'サブスクリプション管理',
    },
    HistoryType: {
        SEEK_SEARCH: '技術情報問答',
        TECH_MIND: '技術ソリューション探索',
        RD_TECH_MIND: '技術ソリューション探索',
        TECH_RESEARCH: '技術予備調査レポート',
        TECH_FMEA: '設計FMEA',
        PATENT_DISCLOSURE: '発明届出書アシスタント',
        MATERIAL_MIND: '技術方案の探索 材料',
        AI_TRANSLATION: 'Patent Translation',
        AI_SPECIFICATION: 'Patent Specification',
        AI_PATENT_DISCLOSURE: 'Invention Disclosure',
        AI_NOVELTY_SEARCH: 'Novelty Search',
        AI_NOVELTY_SEARCH_V2: 'Novelty Search',
        AI_FTO_SEARCH: 'FTO Search',
        AI_NEW_FTO_SEARCH: 'FTO Search',
        AI_FTO_IMAGE: 'Design FTO',
        AI_EOU_AGENT: 'Evidence of Use',
        AI_INVALID_SEARCH: 'Invalid Search',
        AI_GENERATE: 'AI Agent',
        LS_DOCUMENT_QA: 'Biomed Document Analysis',
        LS_CHAT: 'Biomed Q&A Hub',
        LS_MARKUSH_PATENT_DRAFT: 'Markush Claim Drafting',
        TRIZ_MIND: '解決策探索 - Triz',
    },
    GuestToMaster: {
        subject: '無料で試してみる',
        rights: 'Eureka の AI エージェントで業務を自動化・効率化し、イノベーションに集中しよう。',
    },
};

// ========== Edition Tag 相关文案 (从 edition-upgrade 搬运) ==========
const editionTagTw = {
    freemium: '免費版',
    upgrade: '立即升級',
};

const packageDiffTw = {
    singleAirUpgrade: {
        title: '升級解鎖更多權益',
        description: '升級到高級版，解鎖更多功能和數據權限',
        buttonText: '立即升級',
        features: {
            1: '無限次AI對話次數',
            2: '高級圖表可視化功能',
            3: '專屬客服支援',
        },
    },
};

const historyTw = {
    empty: '暫無任務',
    searchPlaceholder: '搜尋任務',
    today: '今天',
    yesterday: '昨天',
};

const PtUserBannerTw = {
    more: '檢視全部 →',
    protect_free: '科技保護',
    protect_trial: '科技保護',
    protect_commercial_old: '科技保護',
    protect_commercial: '科技保護',
    material_trial: '新材料',
    material_commercial_old: '新材料',
    material_commercial: '新材料',
    material_commercial_rapid_search: '材料速研版',
    air_free: 'Eureka 基礎版',
    air_trial: '科技方案',
    air_commercial: '科技方案',
    unlock_skills_trial: 'Eureka 試用版',
    insights_trial: '研發情報',
    insights_commercial: '研發情報',
    air_commercial_professional_edition: '研發專業版',
    air_commercial_professional_edition_trial: '研發專業版',
    air_commercial_navigator_edition: '研發領航版',
    air_commercial_navigator_edition_trial: '研發領航版',
    feishu_trial: 'Eureka 研發專業版（試用）',
    ls_trial: '生物醫藥 (試用)',
    ls_trial_five: '生物醫藥',
    ls_commercial: '生物醫藥',
    ls_commercial_share: '生物醫藥專業版',
    ls_commercial_share_trial: '生物醫藥 (試用)',
    ls_trial_hiro: '生物醫藥百科問答 & 文檔精讀 (試用)',
    ls_trial_hiro_full: '生物醫藥百科問答 & 文檔精讀 (試用)',
    ls_commercial_hiro: '生物醫藥百科問答 & 文檔精讀',
    ls_commercial_pharma: '生物醫藥百科問答 & 文檔精讀',
    ls_commercial_draft: '馬庫什權要撰寫 ',
    ls_commercial_antibody: '優選抗體推薦',
    ls_commercial_launch: '藥物知產報告',
    ls_commercial_agent: '生物醫藥增強包',
    ip_commercial: '知識產權',
    ip_trial_novelty_drafting: '知識產權',
    ip_trial_infringement: '防侵權檢索',
    ip_trial_novelty: '查新檢索',
    ip_commercial_specification_cnipa: '專利說明書撰寫(CNIPA)',
    ip_commercial_specification_uspto: '專利說明書撰寫(USPTO)',
    ip_commercial_specification_epo: '專利說明書撰寫(EPO)',
    ip_commercial_design_infringement: '外觀防侵權檢索',
    ip_commercial_infringement: '防侵權檢索',
    ip_commercial_disclosure: '技術交底書撰寫',
    ip_commercial_translation: '專利翻譯',
    ip_commercial_novelty: '查新檢索',
    ip_commercial_novelty_draft: 'AI查新&撰寫',
    ip_commercial_draft: 'AI撰寫',
    ip_plg_free: 'Eureka IP 通用流量(免費版)',
    GENERAL_FREEMIUM: '免費版',

    rd_plg_freemium: 'Eureka 基礎版',
    rd_personal_commercial: 'Eureka 工程創新 個人版',
    agent_personal_commercial: 'Eureka 個人付費版',
    material_pro: 'MSE Pro',
    ls_plg_personal_pro: 'LS Pro',
    ip_checking_pro: 'IP 檢索 專業版',
    ip_checking_pro_year: 'IP 檢索 專業版',
    ip_checking_enterprise: 'IP 檢索 企業版',
};

// ========== Edition Tag 相关文案结束 ==========
const histroySearchTw = {
    Hiro: '芽仔',
    EOU: '侵權線索發現',
    NoveltySearch: '查新檢索',
    FTOSearch: '防侵權檢索',
    DesignFTOSearch: '外觀防侵權檢索',
    PatentApplication: '專利申請',
    OAR: '審查意見答覆',
    InventionDisclosure: '交底書',
    CustomCap: '客製化功能',
    Telecom: '標準比對',
};
export const tw = {
    editionTag: editionTagTw,
    packageDiff: packageDiffTw,
    history: historyTw,
    histroySearch: histroySearchTw,
    PtUserBanner: PtUserBannerTw,
    IpHeader: {
        ip: 'IP',
        features: '功能介紹',
        pricing: '報價',
        getStarted: '開始體驗',
    },
    AIHistoryNav: {
        open: '展開側欄',
        close: '關閉側欄',
    },
    NavBar: {
        HOME: '首頁',
        NEW_TASKS: '新任務',
        SEARCH_TASKS: '搜尋任務',
        KNOWLEDGE_BASE: '知識庫',
        MONITOR: '情報簡報',
        COMMUNITY: '發現廣場',
        AGENT: '智能體',
        CUSTOMIZE: '個人化',
        DRAFTING: '撰寫',
        AI_STUDIO: 'AI 工作站',
        AI_GENERATE: 'AI Agent',
        WORKSPACE: '工作空間',
        CUSTOM_AGENT: 'Explore',
        WORK_PROJECT: '工作項目',
        MONITOR_TOPIC: '技術库',
        MONITOR_SUBSCRIPTION: '我的監控',
        HISTORY: '最近任務',
        DraftingCenter: '撰寫中心',
        Templates: '模板',
        AIInstructions: '指令',
        WritingStyles: '撰寫風格',
        deleteTitle: '確認刪除記錄',
        deleteContent: '您確定要永久刪除此記錄嗎？刪除後將無法恢復此數據。',
        cancel: '取消',
        confirm: '刪除',
        deleteSuccess: '您的記錄已成功刪除',
        open: '展開側欄',
        close: '關閉側欄',
        INCOGNITO: '已開啟無痕模式',
        INCOGNITO_TIP: '無痕模式下，您的搜索記錄將不會被保存',
        deleteAllTitle: '確認刪除所有緩存及已有記錄',
        deleteAllContent: '您確定要刪除所有數據嗎？刪除後將無法恢復, 您分享的內容也將立即失效。',
        historyViewAll: '全部歷史',
        creditsLabel: '積分',
        manageSubscription: '管理訂閱',
    },
    HistoryType: {
        SEEK_SEARCH: '技術資訊問答',
        TECH_MIND: '技術方案探索',
        RD_TECH_MIND: '技術方案探索',
        TECH_RESEARCH: '技術預研報告',
        TECH_FMEA: '設計失效分析',
        PATENT_DISCLOSURE: '專利交底書助手',
        MATERIAL_MIND: '技術方案探索 材料',
        AI_TRANSLATION: '專利翻譯',
        AI_SPECIFICATION: '專利說明書撰寫',
        AI_PATENT_DISCLOSURE: '技術交底書撰寫',
        AI_NOVELTY_SEARCH: '查新檢索',
        AI_NOVELTY_SEARCH_V2: '查新檢索',
        AI_FTO_SEARCH: '防侵權檢索',
        AI_NEW_FTO_SEARCH: '防侵權檢索',
        AI_FTO_IMAGE: '外觀防侵權檢索',
        AI_EOU_AGENT: '侵權線索發現',
        AI_INVALID_SEARCH: '專利無效分析',
        AI_GENERATE: 'AI Agent',
        LS_DOCUMENT_QA: 'Biomed Document Analysis',
        LS_CHAT: 'Biomed Q&A Hub',
        LS_MARKUSH_PATENT_DRAFT: 'Markush Claim Drafting',
        TRIZ_MIND: '解決方案探索 - Triz',
    },
    GuestToMaster: {
        subject: '免費註冊',
        rights: 'Eureka 賦能您的創新全流程，讓創新更專注、更高效。',
    },
};
